import { FC } from 'react';

import styles from './AbTestFallbackLoadingDiv.module.scss';

const AbTestFallbackLoadingDiv: FC = () => <div className={styles.container} />;

export default AbTestFallbackLoadingDiv;
